import React, {Fragment, useContext, useState} from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, TextField, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { TimeLineOrdenComponent } from './TimeLine';
import { TEXT_BTN, TEXT_REPORT_CO, TYPE_TF_CO} from '../Constants/Const';
import {TableComponent} from "../Global/AgGridTableComponent";
import {AuthContext} from "../Global/AuthContext";
import dayjs from "dayjs";

const VALUE_DIALOG_INIT={
      statusDialog: false,
      dataDialog: null
}

const TALLER = [
      {label:'Taller 1', id:1},
      {label:'Taller 2', id:2},
      {label:'Taller 3', id:3},
]

const TYPE_SERVER = [
      {label: 'Correctivo', id: 6},
      {label: 'Preventivo', id: 3},
]




function DialogConfirmationComponent({openDialog=false, handlingCloseDialog=null, dataRow=null}) {


    const VALUE_INIT = {
        servicio: dataRow.servicio ? dataRow.servicio : null,
        taller: dataRow.taller ? dataRow.taller : null,
        date: dataRow.date ? dataRow.date : dayjs(),
        mecanico_1: dataRow.mecanico_1 ? dataRow.mecanico_1 : null,
        mecanico_2: dataRow.mecanico_2 ? dataRow.mecanico_2 : null,
    }

    const {report, addReport} = useContext(AuthContext);

    const [mechanicalOption] = useState([]);

    const [optionSelected, setOptionSelected] = useState(VALUE_INIT);

    const handlingAddData = (typeTf) => (event, valueRow) => {

            switch (typeTf) {
                  case TYPE_TF_CO.servicio:
                        setOptionSelected({
                              ...optionSelected,
                               servicio: valueRow
                        })
                        return valueRow;
                  case TYPE_TF_CO.date:
                        setOptionSelected({
                              ...optionSelected,
                               date: event
                        })
                        return event;
                  case TYPE_TF_CO.taller:
                        setOptionSelected({
                              ...optionSelected,
                               taller: valueRow
                        })
                        return valueRow;
                  case TYPE_TF_CO.mecanico_1:
                        setOptionSelected({
                              ...optionSelected,
                               mecanico_1: valueRow
                        })
                        return valueRow;
                  case TYPE_TF_CO.mecanico_2:
                        setOptionSelected({
                              ...optionSelected,
                               mecanico_2: valueRow
                        })
                        return valueRow;
                  default:
                        setOptionSelected(optionSelected);
                        return
            }

      }

    const handlingAddreport = () =>{
          let oldreport = report.find(things=> things.id === dataRow.id);
          let data_add_new = {
              ...oldreport,
              ...optionSelected
          }
          let old_report = report.filter(things=> things.id !== dataRow.id);
          let new_reports = [
              ...old_report,
              data_add_new
          ]
          new_reports = new_reports.sort((a, b) => a.id - b.id);
          addReport(new_reports);
          handlingCloseDialog();
      }

    return(
            <Dialog open={openDialog} onClose={handlingCloseDialog} maxWidth="md">
                  <DialogTitle>
                        <Typography variant="h5" >Reporte de falla</Typography>
                  </DialogTitle>

                  <Divider/>

                  <DialogContent>
                        <Grid container spacing={2}>
                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Status"
                                          defaultValue={dataRow.status}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <Autocomplete
                                          disablePortal
                                          options={TYPE_SERVER}
                                          onChange={handlingAddData(TYPE_TF_CO.servicio)}
                                          value={TYPE_SERVER.find(things=> things.id === optionSelected.servicio?.id ) || null}
                                          renderInput={
                                                (params) => <TextField margin="normal" variant="filled" {...params} label={'Tipo de servicio'}/>
                                    }/>
                              </Grid>

                              <Grid item xs={4}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                          <DatePicker
                                              value={optionSelected.date}
                                              onChange={handlingAddData(TYPE_TF_CO.date)}
                                              sx={{marginTop: '3vh'}} disablePast
                                          />
                                    </LocalizationProvider>
                              </Grid>

                              <Grid item xs={4}>
                                    <Autocomplete
                                          disablePortal
                                          options={TALLER}
                                          onChange={handlingAddData(TYPE_TF_CO.taller)}
                                          value={TALLER.find(things=> things.id === optionSelected.taller?.id)  || null}
                                          renderInput={
                                                (params) => <TextField margin="normal" variant="filled" {...params} label={'Selecciona el taller'}/>
                                    }/>
                              </Grid>

                              <Grid item xs={4}>
                                    <Autocomplete
                                          disablePortal
                                          options={optionSelected.mecanico_2 ? mechanicalOption.filter(thing => thing.id !== optionSelected.mecanico_2.id):mechanicalOption}
                                          onChange={handlingAddData(TYPE_TF_CO.mecanico_1)}
                                          value={mechanicalOption.find(things=> things.id === optionSelected.mecanico_1?.id)  || null}
                                          renderInput={
                                                (params) => <TextField margin="normal" variant="filled" {...params} label={'Selecciona el mecanico 1'}/>
                                    }/>
                              </Grid>

                              <Grid item xs={4}>
                                    <Autocomplete
                                          options={optionSelected.mecanico_1? mechanicalOption.filter(thing => thing.id !== optionSelected.mecanico_1.id):mechanicalOption}
                                          onChange={handlingAddData(TYPE_TF_CO.mecanico_2)}
                                          value={mechanicalOption.find(things=> things.id === optionSelected.mecanico_2?.id)  || null}
                                          renderInput={
                                                (params) => <TextField margin="normal" variant="filled" {...params} label={'Selecciona el mecanico 2'}/>
                                    }/>
                              </Grid>

                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Chofer"
                                          defaultValue={dataRow.datosChofer.label}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Unidad"
                                          defaultValue={dataRow.datosUnidad.label}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"                                    
                                          margin="normal"
                                          disabled
                                          label="Descripcion"
                                          defaultValue={dataRow.descripcion}
                                    />
                              </Grid>
                              
                              <Grid item xs={12}>

                                    <Divider/>
                              </Grid>

                              <Grid item xs={12}>
                                    <TimeLineOrdenComponent select={0}/>
                              </Grid>
                        </Grid>



                  </DialogContent>

                  <Divider/>

                  <DialogActions>
                        <Button variant="contained" color="error" onClick={handlingCloseDialog}>
                              <Typography variant='button'>{TEXT_BTN.exit}</Typography>
                        </Button>
                        <Button variant="contained" color="error" onClick={handlingCloseDialog}>
                              <Typography variant='button'>{TEXT_BTN.cancel}</Typography>
                        </Button>
                        <Button variant="contained" color="success" onClick={handlingAddreport}>
                              <Typography variant='button'>{TEXT_BTN.accepted}</Typography>
                        </Button>
                  </DialogActions>

            </Dialog>
      );
}

export function ConfirmationOrderComponent(){

      const {report } = useContext(AuthContext);

      const [showDialog, setshowDialog] = useState(VALUE_DIALOG_INIT)
  
      return (
            <Fragment>

                  <TableComponent
                      titleTable={TEXT_REPORT_CO.title}
                      columnsTable={TEXT_REPORT_CO.columnTable}
                      rowsTable={report}
                      handlingDoubleClick={(event)=>setshowDialog(()=>({dataDialog: event.data, statusDialog:true}))}
                  />
                  

                  {
                        showDialog.statusDialog?
                              <DialogConfirmationComponent
                                    dataRow={showDialog.dataDialog}
                                    openDialog={showDialog.statusDialog}
                                    handlingCloseDialog={()=>setshowDialog(olsState=>({...olsState, statusDialog:false}))}
                              />:null
                  }
            </Fragment>
      );
}